// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-slides, ion-slide {
  height: 100%;
  width: 100%;
}

.codigo_text {
  margin-top: 10px;
  font-size: 1rem;
}
.codigo_text span {
  font-weight: bold;
  color: var(--ion-color-dark);
}

.btn-anadir-quitar-bonos {
  font-size: 1.5rem;
  vertical-align: sub;
}

.contador {
  color: var(--ion-color-primary);
  font-size: 1.5rem;
  padding-left: 5px;
  padding-right: 5px;
}

.div-bono {
  border-top: 1px solid;
  margin-top: 10px;
  padding-top: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/admin/validate-code-modal/validate-code-modal.page.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,WAAA;AACJ;;AACA;EACI,gBAAA;EACA,eAAA;AAEJ;AADI;EACI,iBAAA;EACA,4BAAA;AAGR;;AAAA;EACI,iBAAA;EACA,mBAAA;AAGJ;;AADA;EACI,+BAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AAIJ;;AAFA;EACI,qBAAA;EACA,gBAAA;EACA,gBAAA;AAKJ","sourcesContent":["ion-slides, ion-slide{\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n.codigo_text{\r\n    margin-top: 10px;\r\n    font-size: 1rem;\r\n    span{\r\n        font-weight: bold;\r\n        color: var(--ion-color-dark);\r\n    }\r\n}\r\n.btn-anadir-quitar-bonos{\r\n    font-size: 1.5rem;\r\n    vertical-align: sub;\r\n}\r\n.contador{\r\n    color: var(--ion-color-primary);\r\n    font-size: 1.5rem;\r\n    padding-left: 5px;\r\n    padding-right: 5px;\r\n}\r\n.div-bono{\r\n    border-top: 1px solid;\r\n    margin-top: 10px;\r\n    padding-top: 5px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
